<template>
  <section class="section--comp">
    <div class="container items-center">
      <carousel
        :autoplay="true"
        dir="ltr"
        :autoplay-timeout="5000"
        :perspective="0"
        :loop="true"
        :paginationEnabled="false"
        :perPageCustom="[[320, 2],[1199, 4]]"
      >
        <slide>
          <img src="@/assets/images/aboutUs/pci.png" alt="pci" />
        </slide>

        <slide>
          <img src="@/assets/images/aboutUs/arbunize.png" alt="arbunize" />
        </slide>

        <slide>
          <img src="@/assets/images/aboutUs/partner-logo.png" alt="partner" />
        </slide>

        <slide>
          <img height="75px" src="@/assets/images/aboutUs/peopletree.png" alt="peopletree" />
        </slide>

        <slide>
          <img src="@/assets/images/aboutUs/video-wiki.png" alt="wiki" />
        </slide>
      </carousel>
    </div>
  </section>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";
export default {
  name: "PartnerComp",
  components: { Carousel, Slide },
};
</script>

<style scoped>
/*===============================================*/
/* OUR MISSION	 						 */
/*===============================================*/

.mission-card {
  min-height: 135px;
}

.truncate {
  width: 80%;
  white-space: normal !important;
  margin-left: 1.5rem;
}
.mission__p {
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 30px;
  color: #848199;
}

/*===============================================*/
/* MEDIA QUERIES	 						 */
/*===============================================*/

@media (max-width: 1200px) {
}
</style>
